/* Funtastic — camada "global" (variante C): pesquisa instantânea, carregar mais, ordenar, garagem, WhatsApp, vistos recentemente */
(function(){
'use strict';
var ES = (document.documentElement.lang || 'pt').slice(0,2) === 'es';
var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
function $(s,r){return (r||document).querySelector(s)}
function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
function store(k,v){try{if(v===undefined)return JSON.parse(localStorage.getItem(k)||'null');localStorage.setItem(k,JSON.stringify(v))}catch(e){return null}}

/* ---------- Pesquisa instantânea ---------- */
function initSearch(){
  var box = document.getElementById('FsSearch'); if (!box) return;
  var inp = $('.fs-srch__in', box), res = $('[data-fs-srch-res]', box), idle = res ? res.innerHTML : '';
  var timer = 0, ctrl = null, last = '', opener = null;
  function open(e){
    if (e){ if (e.metaKey || e.ctrlKey) return; e.preventDefault(); }
    opener = document.activeElement;
    box.setAttribute('open',''); document.documentElement.style.overflow = 'hidden';
    setTimeout(function(){ inp.focus(); inp.select(); }, 30);
  }
  function close(){
    box.removeAttribute('open'); document.documentElement.style.overflow = '';
    if (opener && opener.focus) opener.focus();
  }
  function run(q){
    if (q === last) return; last = q;
    if (q.length < 2){ res.innerHTML = idle; return; }
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    res.setAttribute('aria-busy','true');
    var url = ROOT + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=fs-predict&resources[type]=product,collection,page&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
    fetch(url, ctrl ? {signal: ctrl.signal} : {}).then(function(r){ return r.text(); }).then(function(html){
      var d = new DOMParser().parseFromString(html, 'text/html');
      var c = d.querySelector('[data-fs-predict]');
      res.innerHTML = c ? c.innerHTML : idle;
      res.removeAttribute('aria-busy');
    }).catch(function(){ res.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-fs-search]'); if (t){ open(e); return; }
    if (e.target.closest('[data-fs-srch-close]')){ e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && box.hasAttribute('open')) close();
    if (e.key === '/' && !box.hasAttribute('open') && !/INPUT|TEXTAREA|SELECT/.test((document.activeElement||{}).tagName||'')) open(e);
  });
  inp.addEventListener('input', function(){ clearTimeout(timer); var q = inp.value.trim(); timer = setTimeout(function(){ run(q); }, 220); });
}

/* ---------- Ordenar (coleção e pesquisa) ---------- */
function initSort(){
  $$('[data-fs-sort]').forEach(function(sel){
    sel.addEventListener('change', function(){
      var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });
  $$('[data-fs-filter-form]').forEach(function(f){
    f.addEventListener('submit', function(){
      $$('input[type=number]', f).forEach(function(i){ if (i.value === '') i.disabled = true; });
    });
  });
}

/* ---------- Carregar mais ---------- */
function seenIds(grid){
  var s = {};
  $$('[data-ids]', grid).forEach(function(c){ (c.getAttribute('data-ids')||'').split(',').forEach(function(id){ if (id) s[id] = 1; }); });
  return s;
}
function initMore(){
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-fs-more-btn]'); if (!b) return;
    var grid = $('[data-fs-grid]'); if (!grid || !window.fetch) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy','true');
    var href = b.getAttribute('href'), sid = b.getAttribute('data-section');
    var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    fetch(url).then(function(r){ if (!r.ok) throw 0; return r.text(); }).then(function(html){
      var d = new DOMParser().parseFromString(html, 'text/html');
      var g2 = d.querySelector('[data-fs-grid]'), seen = seenIds(grid), first = null;
      if (g2) $$('.fs-card', g2).forEach(function(c){
        var ids = (c.getAttribute('data-ids')||'').split(','), dup = ids.some(function(id){ return id && seen[id]; });
        if (dup) return;
        ids.forEach(function(id){ if (id) seen[id] = 1; });
        $$('img[loading=eager]', c).forEach(function(i){ i.setAttribute('loading','lazy'); });
        grid.appendChild(c); if (!first) first = c;
      });
      var nb = d.querySelector('[data-fs-more-btn]'), pg = d.querySelector('[data-fs-page]');
      if (nb){ b.setAttribute('href', nb.getAttribute('href')); b.removeAttribute('aria-busy'); var mp = $('[data-fs-page]'); if (mp && pg) mp.textContent = pg.textContent; }
      else { var m = b.closest('[data-fs-more]'); if (m) m.remove(); }
      if (window.FS && FS.initCommon) FS.initCommon(grid);
      if (first){ try { first.focus({preventScroll:true}); } catch(x){} }
    }).catch(function(){ window.location.href = href; });
  });
}

/* ---------- Garagem: setas ---------- */
function initGarage(){
  $$('[data-fs-garage]').forEach(function(sec){
    var tr = $('[data-track]', sec), pv = $('[data-g-prev]', sec), nx = $('[data-g-next]', sec);
    if (!tr) return;
    function step(d){ var c = $('.at-car', tr); var w = c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(tr).columnGap || 24) : 320; tr.scrollBy({left: d * w * (window.innerWidth >= 1100 ? 2 : 1), behavior: 'smooth'}); }
    function upd(){ if (pv) pv.disabled = tr.scrollLeft < 8; if (nx) nx.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 8; }
    if (pv) pv.addEventListener('click', function(){ step(-1); });
    if (nx) nx.addEventListener('click', function(){ step(1); });
    tr.addEventListener('scroll', function(){ requestAnimationFrame(upd); }, {passive:true});
    window.addEventListener('resize', upd); upd();
  });
}

/* ---------- WhatsApp: nunca por cima de um botão ou do preço ---------- */
function initWa(){
  var wa = $('.fs-wa-float'); if (!wa) return;
  var SEL = '.at-hero .pr-hero__cta .fs-btn,.fs-model .fs-price--xl,[data-fs-main-btn],[data-fs-sticky][data-show] .fs-btn,[data-fs-sticky][data-show] button,.fs-flt__foot,.fs-more .fs-btn,[data-wa-avoid]';
  var tick = false;
  function hit(){
    tick = false;
    var r = wa.getBoundingClientRect(), pad = 8, hide = false;
    if (!r.width){ return; }
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length && !hide; i++){
      var b = els[i].getBoundingClientRect();
      if (!b.width) continue;
      if (b.left < r.right + pad && b.right > r.left - pad && b.top < r.bottom + pad && b.bottom > r.top - pad) hide = true;
    }
    wa.classList.toggle('is-hidden', hide);
  }
  function q(){ if (!tick){ tick = true; requestAnimationFrame(hit); } }
  window.addEventListener('scroll', q, {passive:true}); window.addEventListener('resize', q);
  setInterval(q, 1200); q();
}

/* ---------- Vistos recentemente ---------- */
function meta(p){ var m = document.querySelector('meta[property="' + p + '"]'); return m ? m.getAttribute('content') : ''; }
function recordRecent(){
  if (!document.body.classList.contains('t-product')) return;
  var url = location.pathname, title = meta('og:title'), img = meta('og:image:secure_url') || meta('og:image'), price = meta('og:price:amount');
  if (!title) return;
  var list = (store('fsRecent') || []).filter(function(x){ return x && x.u !== url; });
  list.unshift({u: url, t: title, i: img, p: price});
  store('fsRecent', list.slice(0, 10));
}
function esc(s){ return String(s||'').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
function renderRecent(){
  var box = $('[data-fs-recent]'); if (!box) return;
  var list = (store('fsRecent') || []).filter(function(x){ return x && x.u && x.u !== location.pathname; }).slice(0, 8);
  if (!list.length) return;
  var out = $('[data-fs-recent-list]', box);
  out.innerHTML = list.map(function(x){
    var name = esc(x.t).split(/ c\/| C\/| com | con /)[0];
    var img = x.i ? esc(x.i.replace(/^http:/, 'https:')) : '';
    if (img) img = img + (img.indexOf('?') > -1 ? '&amp;' : '?') + 'width=240';
    return '<a class="fs-pd__item" href="' + esc(x.u) + '"><span class="fs-pd__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="120" height="90">' : '') + '</span><span class="fs-pd__t"><span class="fs-pd__n">' + name + '</span>' + (x.p ? '<span class="fs-pd__p">' + esc(x.p) + ' €</span>' : '') + '</span></a>';
  }).join('');
  box.hidden = false;
}

/* ---------- Formulário "Avisar que vou": email opcional ---------- */
function initVisit(){
  $$('[data-fs-visit-form]').forEach(function(f){
    f.addEventListener('submit', function(){
      var vis = $('[data-email-visible]', f), real = $('[data-email-real]', f), note = $('[data-email-note]', f);
      var v = vis ? vis.value.trim() : '';
      if (real) real.value = v || real.getAttribute('data-fallback') || '';
      if (note) note.value = v || (ES ? 'no indicado (contactar por teléfono)' : 'não indicado (contactar por telemóvel)');
    });
  });
}

function boot(){ initSearch(); initSort(); initMore(); initGarage(); initWa(); recordRecent(); renderRecent(); initVisit(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
